import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { IconButton, Tooltip } from "@mui/material";
import MessageNotification from "../../Common/MessageNotification";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { useRoute } from "../../Common/route";
import Cookies from "universal-cookie";
import AlterImage from "../../../assets/images/alter_image.png";
import menuIcon from "../../../assets/images/icons/menu_dots_icn.svg";
import { Service } from "../../../Service/ApiService";
import { CommonService } from "../../../Service/CommonService";
import { CookieService } from "../../../Service/CookieService";
import { OrderApiService } from "../../../Service/OrderApiService";
import { RootState } from "../../store";
import { NotificationProvider } from "../../../Websocket/NotificationProvider";
import { setMyCartItems } from "../../store/cartSlice";
import "./ProfileBar.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ManageOwners from "../../../assets/images/icons/ManageOwner.svg";
import Constant from "../../../Constant";

const ProfileBar = () => {
  const history = useHistory();
  const route = useRoute();
  const location = useLocation();
  const currentPath = location.pathname;
  // Define state variables for name and login type
  const [name, setName] = useState<string | null>(null);
  const [loginType, setLoginType] = useState<string | null>(null);
  const [role, setRole] = useState<string | null>(null);
  const [userId, setUserId] = useState("");
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const myCartItems = useSelector((state: RootState) => state.cart.myCartItems);
  const dispatch = useDispatch();
  const loginAsUser = localStorage.getItem("loginAsUser");
  const updateUserName = localStorage.getItem("updateUserName");
  const isWarehouseImpersonation =
    loginAsUser === "yes" && CommonService.isWarehouse();

  const fetchData = async () => {
    if (role != "SUPER_ADMIN") {
      try {
        const response: any = await OrderApiService.getOrderItems();
        console.log("user cart length - " + response?.data?.length);
        //set  count from item for profile
        dispatch(setMyCartItems(response?.data?.length));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  useEffect(() => {
    const handleProfileImageChange = () => {
      // Only update profile image if user is logged in
      if (CommonService.isUserLoggedIn()) {
        setImageSrc(localStorage.getItem("profile"));
      } else {
        setImageSrc(null);
        localStorage.removeItem("profile");
      }
    };
    window.addEventListener("profileImageChanged", handleProfileImageChange);

    return () => {
      window.removeEventListener(
        "profileImageChanged",
        handleProfileImageChange
      );
    };
  }, []);

  const manageOwners = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    history.push("/user/barrel-owners");
  };

  useEffect(() => {

    if(CommonService.isUserLoggedIn()) {
      const fetchUserDetails = () => {
        const cookies = new Cookies();
        const role = cookies.get("userRole");
        setUserId(cookies.get("userId"));

        setRole(role);
        setLoginType(capitalizeString(role));

        const name = cookies.get("userName");
        //setName(name); //Placing the username as same as we get from DB  eg. WDTS User becomes Wdts User for capitalizeString
        // setName(capitalizeString(name));
        setName(loginAsUser && updateUserName && updateUserName !== name ? updateUserName : name);
      };

      function capitalizeString(str: string): string {
        // Check if the string is empty
        if (!str.trim()) {
          return "";
        } else {
          // Split the string into words
          const words = str.split(" ");

          // Capitalize the first letter of each word
          const capitalizedWords = words.map((word) => {
            // Capitalize the first letter of the word
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
          });

          // Join the capitalized words back into a string
          return capitalizedWords.join(" ");
        }
      }

      fetchUserDetails();
      getProfileImage();
    } else {
      // User is not logged in or token is invalid - clear cached profile
      setImageSrc(null);
      localStorage.removeItem("profile");
    }
  }, []);

  useEffect(() => {
    if(CommonService.isUserLoggedIn()) {
      fetchData();
    }
  }, []);

  const logout = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    //call the api for logout user
    try {
      await Service.logout();
    } catch (error) {
      console.log(error);
    }

    //remove the token from the cookies
    CookieService.removeAuthToken();
    // notificationWebSocketService.disconnect();

    //Redirect to a different route, then back for clear the cache
    if(!currentPath.startsWith("/user/inventories")) {
       history.push("/user/inventories");
    } else {
      history.push("/temp");
      setTimeout(() => {
        history.push("/user/inventories");
      }, 0);
    }
  
  };

  //redirect to the profile page
  const handleProfile = () => {
    if (!CommonService.isUserLoggedIn()) {
      CommonService.Toast.fire({
        title: "You’re not signed in. Please log in to access this feature.",
        icon: "warning",
      });
      return;
    }
    (CommonService.isAdmin() || CommonService.isWarehouse())
      ? history.push("/master/my-profile/" + userId)
      : history.push("/user/my-profile/" + userId);
  };

  const getProfileImage = async () => {
    // Validate user is logged in before fetching profile
    if (!CommonService.isUserLoggedIn()) {
      setImageSrc(null);
      localStorage.removeItem("profile");
      return;
    }

    if (CommonService.getProfile() == null) {
      const requestDto = {
        id: CommonService.getUserId(),
      };
      try {
        const response: any = await Service.getProfileImage(requestDto);
        const blob = response.data as Blob;
        if (blob.size != 0) {
          // Create a URL for the Blob and set it as the image source
          const imageUrl = URL.createObjectURL(blob);
          setImageSrc(imageUrl);
          localStorage.setItem("profile", imageUrl);
        } else {
          setImageSrc(null);
        }
      } catch (error) {
        console.error("Error occured on fetching profile picture:", error);
        // If API call fails (e.g., invalid token), clear cached image
        setImageSrc(null);
        localStorage.removeItem("profile");
      }
    } else {
      setImageSrc(CommonService.getProfile());
    }
  };

  return (
    <>
      <div className="profile__bar d-inline-flex align-items-center justify-content-between px-2 ms-auto">
        <div className="profile__bar--info d-inline-flex align-items-center">
          {CommonService.isUserLoggedIn() && (<NotificationProvider userId={userId}>
            {/* <Container className='p-0'> */}

            <div className="profile--notification me-2">
              {/* //add the message Notification such that only show the count and icon when i click then show the list of messages */}
              <MessageNotification userId={userId} />
            </div>
            {/* </Container> */}
          </NotificationProvider>)}


          {CommonService.isUserLoggedIn() && (!CommonService.isAdmin() && !CommonService.isWarehouse()) && (
            <div className="profile--notification profile--cart me-2">
              <Tooltip title="My Cart" arrow>
                <IconButton
                  aria-label="delete"
                  onClick={() => route("/user/my-cart")}
                  className="btn-basic"
                >
                  <ShoppingCartOutlinedIcon />
                  {myCartItems > 0 && (
                    <span
                      className="msg-count"
                      aria-label={`${myCartItems} notifications`}
                    >
                      {myCartItems}
                    </span>
                  )}
                </IconButton>
              </Tooltip>
            </div>
          )}
          <div
            className="profile--pic me-2 cursor-pointer"
            onClick={() => {
              if (!CommonService.isUserLoggedIn() ) {
                CommonService.Toast.fire({
                    title: "You’re not signed in. Please log in to access this feature.",
                    icon: "warning",
                });
                return;
              }
              handleProfile();
            }}
          >
            <img
              src={CommonService.isUserLoggedIn() ? (imageSrc || AlterImage) : AlterImage}
              alt="userImg"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.onerror = null; // Prevent infinite loop if the fallback image fails
                target.src = AlterImage;
                localStorage.removeItem("profile");
              }}
            />
          </div>
          {/*<div className={`profile--name cursor-pointer ${!CommonService.isUserLoggedIn() && 'me-2'}`} onClick={handleProfile}>
            {(updateUserName === null ? name : updateUserName || !CommonService.isUserLoggedIn()) && <h2 className="name mb-0">{CommonService.isUserLoggedIn()  ? updateUserName === null ? name : updateUserName : "Guest"}</h2>}
          </div>*/}
          <div className={`profile--name cursor-pointer ${!CommonService.isUserLoggedIn() ? "me-2" : ""}`} onClick={handleProfile}>
            <h2 className="name mb-0">
              {!CommonService.isUserLoggedIn() ? "Guest" : loginAsUser ? (name || "Guest") : (updateUserName || name || "Guest")}</h2>
          </div>

        </div>
        {CommonService.isUserLoggedIn() && !isWarehouseImpersonation && (<div className="profile__bar--menu ms-2">
          <div className="dropdown">
            <button
              className="btn dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img src={menuIcon} alt="menuIcon" />
            </button>
            <ul className="dropdown-menu">
              {CommonService.isAdmin() && (
                <>
                  <li>
                    <a
                      className="dropdown-item d-flex align-items-center gap-2"
                      aria-current="page"
                      onClick={() => route("/master/barrel-sync-log")}
                      role="button"
                      aria-expanded="false"
                    >
                      <FontAwesomeIcon
                        icon={faArrowsRotate}
                        style={{ marginRight: "1.7px" }}
                      />
                      Container Sync Log
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item d-flex align-items-center"
                      aria-current="page"
                      onClick={() =>
                        CommonService.isAdmin()
                          ? route("/master/insurance-pricing")
                          : route("/user/barrel-market-value")
                      }
                      role="button"
                      aria-expanded="false"
                      style={{ paddingLeft: "12px" }}
                    >
                      <AttachMoneyIcon />
                      Container values
                    </a>
                  </li>
                </>
              )}
              {CommonService.isUser() && (
                <li>
                  <a
                    className="dropdown-item d-flex align-items-center"
                    href="#"
                    style={{ paddingLeft: 15 }}
                    onClick={(e) => manageOwners(e)}
                  >
                    <img src={ManageOwners} alt="manage owner" />
                    Manage Owners
                  </a>
                </li>
              )}
              {!loginAsUser && (
              <li>
                <a
                  className="dropdown-item d-flex align-items-center"
                  href="#"
                  style={{ paddingLeft: 15 }}
                  onClick={(e) => logout(e)}
                >
                  <LogoutRoundedIcon fontSize="small" sx={{ mr: 0.2 }} />
                  Logout
                </a>
              </li>
              )}
            </ul>
          </div>
        </div>)}
      </div>
    </>
  );
};

export default ProfileBar;
